import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestBase } from './request-base';

/**
 * Ablaufprotokolle der Workflows: welcher Baustein wurde betreten, ueber welchen Ausgang
 * verlassen, welche Skriptzeile lief. Geschrieben wird waehrend des Laufs, deshalb laesst
 * sich auch ein noch laufender oder haengender Lauf ansehen.
 */
@Injectable()
export class WorkflowTraceService extends RequestBase {
    BasePath = 'api/workflowtrace';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    GetRuns(workflowID?: string, take = 100): Observable<any> {
        const wf = workflowID ? '&workflowID=' + workflowID : '';
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetRuns?take=' + take + wf, this.options);
    }

    /** Ab fromIndex, damit ein laufender Lauf nachgeladen werden kann, ohne alles erneut zu holen. */
    GetLines(runID: string, fromIndex = 0, take = 1000): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath
            + '/GetLines?runID=' + runID + '&fromIndex=' + fromIndex + '&take=' + take, this.options);
    }

    GetSettings(): Observable<any> {
        return this.http.get<any>(this.API_BASE_URL + this.BasePath + '/GetSettings', this.options);
    }

    SaveSettings(settings): Observable<any> {
        return this.http.post<any>(this.API_BASE_URL + this.BasePath + '/SaveSettings', settings, this.options);
    }
}
